import { create } from "zustand";

const useSurgicalStore = create((set) => ({
  currentSession:null,
  transcript: null,
  audio_url: null,
  surgicalId: null,
  loading: false,
  surgicalNote:null,

  setCurrentSession:(session)=> set({currentSession:session}),
  setTranscriptData: (data) => set({ transcript: data }),
  setAudioUrlData: (url) => set({ audio_url: url }),
  setSurgicalId: (id) => set({ surgicalId: id }),
  setLoading: (data) => set({ loading: data }),
  setSurgicalNote: (data)=> set({surgicalNote:data}),

  getSurgicalDetail: async (surgicalId) => {
    const token = sessionStorage.getItem("token");
    set({ loading: true });
    const url = `${process.env.REACT_APP_SERVER_URL}/surgical-note/files/${surgicalId}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        set({ loading: false });
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("surgical note is fetched using id: ",surgicalId)
      console.log(data);
      set({ loading: false });
      set({
        transcript: data.transcript,
        audio_url: data.recording_file,
        surgicalNote:data.surgicalNote,
      });
    } catch (error) {
      set({ loading: false });
      console.error("Error fetching consultation details:", error);
    }
  },
}));

export default useSurgicalStore;
